// extracted by mini-css-extract-plugin
export default {"content":"TabContent_content__wgLVC","texto":"TabContent_texto__L9SsY","containerImg":"TabContent_containerImg__NDT3F","backgroundSvg":"TabContent_backgroundSvg__Bdu3X"};